import { useTranslation } from 'react-i18next';
import { ArrowLeftToLine, ArrowRightToLine } from 'lucide-react';
import { cx } from 'class-variance-authority';

type Props = {
  setMenuOpen: () => void;
  isMenuOpen: boolean;
};

function ToggleMenuButton({ setMenuOpen, isMenuOpen }: Props) {
  const { t } = useTranslation('navigation');

  const toggleMenu = () => {
    setMenuOpen();
  };
  return (
    <button onClick={toggleMenu} className="mx-2">
      <div
        className={cx(
          'mb-3 flex h-12 items-center rounded-full text-white hover:bg-white/20',
          'px-3',
          !isMenuOpen && 'mx-auto w-fit justify-center px-0',
          isMenuOpen && 'justify-start gap-3',
        )}
      >
        {isMenuOpen ? <ArrowLeftToLine /> : <ArrowRightToLine />}
        {isMenuOpen && <p>{t('collapseMenu')}</p>}
      </div>
    </button>
  );
}

export default ToggleMenuButton;
